import React from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { ActiveLobProps } from './types';
import styles from './index.module.scss';

function Attributes({
  attributes,
}: {
  attributes?: Pick<ActiveLobProps, 'attributes'>;
}) {
  return (
    <div className={styles.attributes}>
      {Array.isArray(attributes) &&
        attributes.map(({ name, value }) => (
          <div>
            <Text>{name} : &nbsp;</Text>
            <Text type="sublabel">{value}</Text>
          </div>
        ))}
    </div>
  );
}

export default Attributes;
